module.exports = __webpack_public_path__ + "media/singing.96016881.mp4";